export default interface WxTemplateInterface {
  content: string;
  deputyIndustry: string;
  example: string;
  primaryIndustry: string;
  templateId: string;
  title: string;
}

export default class WxTemplate implements WxTemplateInterface {
  public content: string;
  public deputyIndustry: string;
  public example: string;
  public templateId: string;
  public title: string;

  constructor(tpl: WxTemplateInterface) {
    this.content = tpl.content;
    this.deputyIndustry = tpl.deputyIndustry;
    this.example = tpl.example;
    this.templateId = tpl.templateId;
    this.title = tpl.title;
  }
}
